import "./AiReport.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";

import ReactMarkdown from "react-markdown";

import { openModal } from "../../../slices/modalSlice";
import { fetchAiReport } from "../../../slices/aiReportSlice";

import { Button } from "../../../common-components/Buttons/Buttons";

import AiReportPeriodModal from "../AiReportPeriodModal/AiReportPeriodModal";

const AiReport = () => {
    const dispatch = useDispatch();

    const token = useSelector((state) => state.auth.token);
    const aiReport = useSelector((state) => state.aiReport.data);
    const remainingQueries = useSelector((state) => state.aiReport.remainingQueries);
    const loadingStatus = useSelector((state) => state.aiReport.loadingStatus);
    const error = useSelector((state) => state.aiReport.error);

    const isLoading = loadingStatus === "loading";

    const handleFetchWeek = () => {
        dispatch(
            fetchAiReport({
                token,
                dateInterval: "week"
            })
        );
    };

    const handleFetchMonth = () => {
        dispatch(
            fetchAiReport({
                token,
                dateInterval: "month"
            })
        );
    };

    const handleOpenCustomPeriodModal = () => {
        dispatch(
            openModal({
                closeable: true,
                content: <AiReportPeriodModal />
            })
        );
    };

    return (
        <Box className="ai_report_drawer">
            <Box className="ai_report_drawer_header">
                <Button
                    title="За неделю"
                    onClick={handleFetchWeek}
                    textColor="#ffffff"
                />

                <Button
                    title="За месяц"
                    onClick={handleFetchMonth}
                    textColor="#ffffff"
                />

                <Button
                    title="За период"
                    onClick={handleOpenCustomPeriodModal}
                    textColor="#ffffff"
                />
            </Box>

            {remainingQueries !== null && (
                <Box
                    className={`ai_report_alert ${
                        remainingQueries === 0 ? "danger" : ""
                    }`}
                >
                    {remainingQueries === 0
                        ? "Лимит запросов исчерпан"
                        : `Осталось запросов: ${remainingQueries}`}
                </Box>
            )}

            <Box className="ai_report_drawer_body">
                {isLoading ? (
                    <Box className="ai_report_loader_full">
                        <CircularProgress size={36} />

                        <Box className="ai_report_loader_text">
                            Думаю...
                        </Box>
                    </Box>
                ) : error ? (
                    <Box className="ai_report_drawer_error">
                        Не удалось загрузить AI-отчет
                    </Box>
                ) : !aiReport ? (
                    <Box className="ai_report_drawer_placeholder">
                        Выберите период для загрузки AI-аналитики
                    </Box>
                ) : (
                    <Box className="ai_report_result_wrapper">
                        <Box className="ai_report_drawer_text markdown_body">
                            <ReactMarkdown>
                                {aiReport}
                            </ReactMarkdown>
                        </Box>

                        <Box className="ai_report_warning">
                            AI агент может допускать ошибки. Рекомендуем проверять важную информацию
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default AiReport;